export default __webpack_public_path__ + "static/media/vto-avatar.fdec07b3.svg";